<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="parametros.dialogError"
    persistent
    max-width="400"
  >
    <v-card>
    	<v-card-text>
  			<v-card class="elevation-0 text-center pt-4">
  				<span class="text-headline">
  				 	{{ parametros.mensaje }}
  				</span>
  			</v-card>
    	</v-card-text>
    	<v-card-actions>
		    <v-btn :color="parametros.color" dark block @click="parametros.dialogError = false">Cerrar</v-btn>
    	</v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
	import { esBloqueoCiclo, dispararBloqueoCiclo } from '@/utils/bloqueoCiclo'

	export default {
		props:[
			'parametros'
	  ],
	  watch: {
	    'parametros.dialogError': {
	      immediate: true,
	      handler (abierto) {
	        if (!abierto || !this.parametros) return
	        if (!esBloqueoCiclo(this.parametros)) return
	        this.parametros.dialogError = false
	        dispararBloqueoCiclo(this.parametros)
	      }
	    }
	  },
	}
</script>